export default {
    share: true
}